export default {
    share: true
}